// src/components/admin/nornsweave/modals/EditBookingModal.js
import React from 'react';
import TimePicker from '../../../TimePicker';

function EditBookingModal({ booking, setBooking, onClose, onSubmit }) {
  if (!booking) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
        <h3 className="text-2xl font-bold text-slate-800 mb-4">Edit Booking</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-slate-700 text-sm font-medium mb-1">Teacher Name</label>
              <input
                type="text"
                required
                className="w-full px-3 py-2 border border-slate-300 rounded-lg"
                value={booking.teacherName}
                onChange={(e) => setBooking({...booking, teacherName: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-slate-700 text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                required
                className="w-full px-3 py-2 border border-slate-300 rounded-lg"
                value={booking.teacherEmail}
                onChange={(e) => setBooking({...booking, teacherEmail: e.target.value})}
              />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-slate-700 text-sm font-medium mb-1">Grade</label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-slate-300 rounded-lg"
                value={booking.grade || ''}
                onChange={(e) => setBooking({...booking, grade: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-slate-700 text-sm font-medium mb-1">Student Count</label>
              <input
                type="number"
                className="w-full px-3 py-2 border border-slate-300 rounded-lg"
                value={booking.studentCount || ''}
                onChange={(e) => setBooking({...booking, studentCount: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-slate-700 text-sm font-medium mb-1">Library</label>
              <select
                className="w-full px-3 py-2 border border-slate-300 rounded-lg"
                value={booking.library}
                onChange={(e) => setBooking({...booking, library: e.target.value})}
              >
                <option value="elementary">Elementary</option>
                <option value="middle">Middle School</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-slate-700 text-sm font-medium mb-1">Date</label>
              <input
                type="date"
                required
                className="w-full px-3 py-2 border border-slate-300 rounded-lg"
                value={booking.date}
                onChange={(e) => setBooking({...booking, date: e.target.value})}
              />
            </div>
            <TimePicker
              label="Start Time"
              value={booking.startTime}
              onChange={(val) => setBooking({...booking, startTime: val})}
              required
            />
            <TimePicker
              label="End Time"
              value={booking.endTime}
              onChange={(val) => setBooking({...booking, endTime: val})}
              required
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Purpose</label>
            <input
              type="text"
              required
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={booking.purpose}
              onChange={(e) => setBooking({...booking, purpose: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Notes</label>
            <textarea
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              rows="3"
              value={booking.notes || ''}
              onChange={(e) => setBooking({...booking, notes: e.target.value})}
            />
          </div>
          <div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={booking.needsLibrarian}
                onChange={(e) => setBooking({...booking, needsLibrarian: e.target.checked})}
                className="w-4 h-4"
              />
              <span className="text-slate-700 font-medium">Needs librarian present</span>
            </label>
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 text-slate-700 py-2 rounded-lg hover:bg-slate-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 bg-purple-600 text-white py-2 rounded-lg hover:bg-purple-700"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditBookingModal;
